<template>
  <!--content-body-->
  <article class="error-form">
    <article class="error-box">
      <div class="txt-area">
        <img
          :src="require('@/assets/images/common/img-error.svg')"
          alt="404페이지 이미지"
        />
        <strong>요청하신 페이지를 찾을 수 없습니다.</strong>
        <p>
          요청하신 페이지를 찾을 수 없습니다.<br />
          찾으시려는 페이지는 주소를 잘못 입력하였거나<br />
          페이지 주소의 변경 또는 삭제등의 이유로 페이지를 찾을 수 없습니다.<br />
          입력하신 페이지의 주소와 경로가 정확한지 한번 더 확인 후 이용하시기
          바랍니다.
        </p>
      </div>
      <div class="btn-area">
        <ColorButton
          color="purpleBorder"
          :width="240"
          :height="50"
          :fontSize="18"
          @click="$pushQueryString('/main')"
        >
          <template #title>메인화면으로 돌아가기</template>
        </ColorButton>
      </div>
    </article>
  </article>
</template>

<script>
import ColorButton from '@/components/button/ColorButton.vue';

export default {
  components: {
    ColorButton,
  },
};
</script>
